import { render, staticRenderFns } from "./Poveznice.vue?vue&type=template&id=63350398&scoped=true&"
import script from "./Poveznice.vue?vue&type=script&lang=js&"
export * from "./Poveznice.vue?vue&type=script&lang=js&"
import style0 from "./Poveznice.vue?vue&type=style&index=0&id=63350398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63350398",
  null
  
)

export default component.exports